<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">活动排期</h3>
                </div>
                <div class="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
                  <button
                    @click="editAction"
                    class="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded text-sm"
                    type="button"
                  >
                    <i class="fas fa-plus mr-1"></i>
                    新增活动排期
                  </button>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
    <el-form :inline="true" ref="ruleForm" :model="formInline" class="demo-form-inline">
      <el-form-item label="上架时间">
        <el-date-picker type="daterange" v-model="usage_time" range-separator="~" start-placeholder="开始日期"
          end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryData()">查询</el-button>
        <el-button @click="onReset('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table style="margin-top: 16px;" v-loading="loading" :data="tableData" border @sort-change="handleSortChange">
      <el-table-column prop="goods_name" label="商品名称" width="140"></el-table-column>
      <el-table-column prop="days" label="上架天数" width="60"></el-table-column>
      <el-table-column prop="sponsor_name" label="赞助商" width="140"></el-table-column>
      <el-table-column label="计划上架时间">
        <template #default="scope">
          <p v-if="scope.row.t_start">{{ formatTime('yyyy-MM-dd hh:mm', scope.row.t_start * 1000) }}</p>
        </template>
      </el-table-column>
      <el-table-column label="实际上架时间">
        <template #default="scope">
          <p v-if="scope.row.t_onsale">{{ formatTime('yyyy-MM-dd hh:mm', scope.row.t_onsale * 1000) }}</p>
        </template>
      </el-table-column>
      <el-table-column label="参与条件" prop="join_condition">
        <template #default="scope">
          {{ joinConditionText(scope.row.join_condition) }}
        </template>
      </el-table-column>
      <el-table-column label="具体参与条件" prop="join_condition_value">
        <template #default="scope">
          {{ joinConditionValueText(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="是否置顶" width="80">
        <template #default="scope">
          <el-tag :type="scope.row.is_top ? 'success' : 'info'">
            {{ scope.row.is_top ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="优先推送" width="80">
        <template #default="scope">
          <el-tag :type="scope.row.is_priority ? 'warning' : 'info'">
            {{ scope.row.is_priority ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="审批状态">
        <template #default="scope">
          <p>{{ getStatusText(scope.row.status) }}</p>
          <template v-if="scope.row.status == 3">
            <p>{{ scope.row.task_id }}</p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" @click="editAction(scope.row)"
            :disabled="scope.row.status == 1 || scope.row.status == 3">编辑</el-button>
          <el-button type="text" @click="deleteAction(scope.row._id)" :disabled="scope.row.status == 3">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 16px; text-align: right" background
      layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[20, 50, 100]"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-size="pageSize">
    </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog :title="editItem.id ? '编辑' : '新增排期'" v-model="formOpen">
      <el-form label-position="right" label-width="150px" :model="editItem" :rules="formRules">
        <el-form-item label="商品名称" required>
          <div class="goods-picker">
            <el-input
              v-model="goodsKeyword"
              clearable
              placeholder="请输入商品名称筛选"
              @focus="goodsPickerOpen = true"
              @input="goodsPickerOpen = true"
              @clear="clearGoodsSelection"
              @keydown.esc="goodsPickerOpen = false"
            />
            <div v-if="goodsPickerOpen" class="goods-picker__options">
              <button
                v-for="item in filteredGoodsList"
                :key="item._id"
                :class="['goods-picker__option', { 'is-selected': item._id === editItem.goods_id }]"
                type="button"
                @mousedown.prevent
                @click="selectGoods(item)"
              >
                {{ item.name }}
              </button>
              <div v-if="!filteredGoodsList.length" class="goods-picker__empty">未找到匹配商品</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="赞助商" required>
          <el-select v-model="editItem.sponsor_id" placeholder="请选择赞助商">
            <el-option v-for="item in sponsor_list" :key="item._id" :label="item.name" :value="item._id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架天数" prop="days">
          <el-input-number style="text-align: left;" v-model="editItem.days" :min="3" :max="31"></el-input-number>
        </el-form-item>
        <el-form-item label="计划上架日期">
          <el-date-picker v-model="editItem.t_start" type="datetime"
            :default-time="defaultScheduleTime" :picker-options="datePickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="参与条件">
          <el-select v-model="editItem.join_condition" placeholder="请选择参与条件">
            <el-option label="无门槛" :value="0"></el-option>
            <el-option label="看视频广告" :value="1"></el-option>
            <el-option label="体验小程序" :value="2"></el-option>
            <!-- <el-option label="关注公众号" :value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item v-if="editItem.join_condition == 2" label="选择小程序">
          <el-select v-model="editItem.join_condition_value" placeholder="请选择小程序">
            <el-option v-for="item in miniAppList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="editItem.join_condition == 3" label="选择公众号">
          <el-select v-model="editItem.join_condition_value" placeholder="请选择公众号">
            <el-option v-for="item in wechatMpList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="editItem.status" placeholder="请选择审核状态">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-switch
            v-model="editItem.is_top"
            active-text="是"
            inactive-text="否">
          </el-switch>
        </el-form-item>
        <el-form-item label="当日优先推送">
          <el-switch
            v-model="editItem.is_priority"
            active-text="是"
            inactive-text="否">
          </el-switch>
        </el-form-item>
        <!-- <el-form-item label="助力条件">
          <el-select v-model="editItem.help_condition" placeholder="请选择助力任务">
            <el-option label="看视频广告" :value="1"></el-option>
            <el-option label="体验小程序" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="editItem.help_condition == 2" label="选择助力小程序">
          <el-select v-model="editItem.help_condition_value" placeholder="请选择助力小程序">
            <el-option v-for="item in miniAppList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <template #footer><span style="display: flex;align-items: center;justify-content: flex-end;">
        <el-button @click="formOpen = false">取消</el-button>
        <el-button @click="updateSchedule" type="primary">确定</el-button>
      </span></template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      registration: [],
      usage_time: [],
      formInline: {
        // user_id: '',
        sctime: '',
        ectime: '',
        // pay_status: null,
        // order_id: '',
      },
      statusOptions: [
        {
          label: '待审核',
          value: 0,
        },
        {
          label: '审批通过-待上架',
          value: 1
        },
        {
          label: '审批拒绝',
          value: 2
        },
        // {
        //   label: '已上架',
        //   value: 3
        // }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1000);
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1000);
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1000);
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 180000;
        }
      },
      defaultScheduleTime: new Date(2000, 0, 1, 12, 0, 0),
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      loading: false,
      formOpen: false,
      editItem: {
        join_condition: 0,
        join_condition_value: '',
        help_condition: 0,
        help_condition_value: '',
        is_top: false,
        is_priority: false,
      },
      formRules: {
        days: [
          { required: true, message: '请输入上架天数', trigger: 'blur' }
        ]
      },
      goods_list: [],
      goodsKeyword: '',
      goodsPickerOpen: false,
      sponsor_list: [],
      miniAppList: [
        { id: 'wx2aed548e27e28de9', name: '立吉答题' },
        { id: 'wxee55405953922c86', name: '小小签到' },
        { id: 'wxfaa08012777a431e', name: '报名工具' },
        { id: 'wx17665654173aa520', name: '立吉2048' },
        { id: 'wx3f0d7dc262b69bbf', name: '立吉去水印' },
        { id: 'wxcf424c4bef17d9b6', name: '立吉投票' },
        { id: 'wx58607abe7f57b91c', name: '我们爱抽奖'},
        { id: 'wxb42d54f49ad88920', name: '立吉查询' },
        { id: 'wx4fc8c5789307af10', name: '立吉优惠' },
        { id: 'wx0856ec82eff5128a', name: '立吉拍照|水印相机' },
      ],
      wechatMpList: [
        { id: 'wx7145c571b99a8368', name: '小小签到' },
        { id: 'wxa3ae3231113552da', name: '立吉答题' },
        { id: 'wx598ea48b7ca912fe', name: '我们爱抽奖' },
      ],
    };
  },
  mounted() {
    this.getSponsorList()
    this.getGoodsList()
    this.queryData();
  },
  computed: {
    filteredGoodsList() {
      const keyword = this.goodsKeyword.trim().toLocaleLowerCase();
      if (!keyword) {
        return this.goods_list;
      }
      return this.goods_list.filter((item) => item.name.toLocaleLowerCase().includes(keyword));
    },
  },
  methods: {
    getSponsorList() {
      this.$$getSponsorList(
        {
          page: 1,
          page_size: 500
        },
        (res) => {
          if (res.sta === 0) {
            this.sponsor_list = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error('请求数据失败!');
        },
      );
    },
    getGoodsList() {
      this.$$getDailyGoodsList({
        page: 1,
        page_size: 500
      }, (res) => {
        if (res.sta === 0) {
          const { list } = res.data
          this.goods_list = list
          const selectedGoods = list.find((item) => item._id === this.editItem.goods_id);
          if (selectedGoods && !this.goodsKeyword) {
            this.goodsKeyword = selectedGoods.name;
          }
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.$message.error('请求数据失败')
      })
    },
    editAction(item = null) {
      if (item) {
        this.editItem = {
          days: item.days,
          t_start: new Date(item.t_start * 1000),
          id: item._id,
          goods_id: item.goods_id,
          sponsor_id: item.sponsor_id,
          status: item.status,
          join_condition: item.join_condition,
          join_condition_value: item.join_condition_val,
          help_condition: item.help_condition,
          help_condition_value: item.help_condition_val,
          is_top: item.is_top,
          is_priority: item.is_priority,
        }
        this.goodsKeyword = item.goods_name || '';
      } else {
        this.editItem = {
          days: 3,
          t_start: null,
          goods_id: '',
          sponsor_id: '',
          status: 0,
          join_condition: 0,
          join_condition_value: '',
          help_condition: 1,
          help_condition_value: '',
          is_top: false,
          is_priority: false,
        }
        this.goodsKeyword = '';
      }

      this.goodsPickerOpen = false;
      this.formOpen = true
    },
    selectGoods(item) {
      this.editItem.goods_id = item._id;
      this.goodsKeyword = item.name;
      this.goodsPickerOpen = false;
    },
    clearGoodsSelection() {
      this.editItem.goods_id = '';
      this.goodsPickerOpen = true;
    },
    deleteAction(id) {
      this.$confirm('是否确认删除', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$$deleteSchedule({
          data: {
            id
          }
        }, (res) => {
          if (res.sta === 0) {
            this.queryData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => { })
      })
    },
    getStatusText(status) {
      if (status == 0) {
        return '待审核'
      } else if (status == 1) {
        return '审批通过-待上架'
      } else if (status == 2) {
        return '审批拒绝'
      } else if (status == 3) {
        return '已上架'
      }
    },
    formatTime(pattern, value) {
      if (!value) return '';
      const date = new Date(value);
      const pad = (num) => String(num).padStart(2, '0');
      return pattern
        .replace('yyyy', date.getFullYear())
        .replace('MM', pad(date.getMonth() + 1))
        .replace('dd', pad(date.getDate()))
        .replace('hh', pad(date.getHours()))
        .replace('mm', pad(date.getMinutes()));
    },
    queryData(sort) {
      if (this.usage_time.length) {
        // eslint-disable-next-line prefer-destructuring
        this.formInline.sctime = this.usage_time[0].getTime() / 1000;
        // eslint-disable-next-line prefer-destructuring
        this.formInline.ectime = this.usage_time[1].getTime() / 1000;
      }
      const params = {
        page: this.currentPage,
        page_size: this.pageSize,
        ...this.formInline,
      };
      if (sort) params.sort = sort;

      this.loading = true;
      this.$$getScheduleList(
        params,
        (res) => {
          if (res.sta === 0) {
            this.loading = false;
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        },
        () => {
          this.loading = false;
          this.$message.error('请求数据失败!');
        },
      );
    },
    onReset(formName) {
      this.usage_time = [];
      this.$refs[formName].resetFields();
      this.formInline = {
        user_id: '',
        sctime: '',
        ectime: '',
        pay_status: null,
        order_id: '',
      };
      this.queryData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryData();
    },
    handleSortChange(obj) {
      this.queryData({
        sort_key: obj.prop,
        sort_type: obj.order === "ascending" ? 1 : -1,
      });
    },
    onDateChange(e) {
      console.info(e)
    },
    updateSchedule() {
      if (!this.editItem.goods_id) {
        return this.$message.error('请选择商品')
      }
      if (!this.editItem.sponsor_id) {
        return this.$message.error('请选择赞助商')
      }
      if (!this.editItem.days) {
        return this.$message.error('请输入上架天数')
      }
      if (!this.editItem.t_start) {
        return this.$message.error('请选择计划上架日期')
      }
      let params = {
        ...this.editItem,
        t_start: this.editItem.t_start.getTime() / 1000
      }
      if (this.editItem.id) {
        this.$$updateSchedule(params, (res) => {
          if (res.sta === 0) {
            this.formOpen = false
            this.queryData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('请求数据失败!');
        })
      } else {
        this.$$addSchedule(params, (res) => {
          if (res.sta === 0) {
            this.formOpen = false
            this.queryData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('请求数据失败!');
        })
      }

    },
    joinConditionText(val) {
      switch (val) {
        case 0: return '无条件';
        case 1: return '看广告';
        case 2: return '体验小程序';
        case 3: return '关注公众号';
        default: return '-';
      }
    },
    joinConditionValueText(row) {
      if (row.join_condition == 2) {
        // 小程序
        const app = this.miniAppList.find(item => item.id === row.join_condition_val);
        return app ? app.name : '-';
      }
      if (row.join_condition == 3) {
        // 公众号
        const mp = this.wechatMpList.find(item => item.id === row.join_condition_val);
        return mp ? mp.name : '-';
      }
      return '-';
    },
  },
};
</script>

<style>
.goods-picker {
  position: relative;
  width: 100%;
}

.goods-picker__options {
  position: absolute;
  z-index: 10;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.goods-picker__option {
  display: block;
  width: 100%;
  padding: 8px 12px;
  color: #606266;
  text-align: left;
  background: #fff;
  border: 0;
  cursor: pointer;
}

.goods-picker__option:hover,
.goods-picker__option.is-selected {
  color: #409eff;
  background: #f5f7fa;
}

.goods-picker__empty {
  padding: 8px 12px;
  color: #909399;
}
</style>
